// function titleCase(str) {
//     str = str.split(re);
//     var outputCamelCase = '';
//     var newArray = str.map(singleWord => {
//         var titledWord = '';
//         for (var i = 0; i < singleWord.length; i++) {
//             if (i === 0) {
//                 titledWord = titledWord + singleWord[i].toUpperCase();
//             } else {
//                 titledWord = titledWord + singleWord[i].toLowerCase();
//             }
//         }
//         outputCamelCase = outputCamelCase + titledWord + ' ';
//     });
//     return outputCamelCase.trim();
// }

function splitCamelCaseToString(s) {
    let newItem = s.split(/(?=[A-Z])/).join(' ');
    let aNewItem =
        newItem.substr(0, 1).toUpperCase() +
        newItem.substr(1, newItem.length - 1);

    return aNewItem;
}

export default splitCamelCaseToString;
